module.exports = __webpack_public_path__ + "static/img/plakaty.2d77e518.png";